import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FilterService, BaseFilterCellComponent } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor } from '@progress/kendo-data-query';

@Component({
  selector: 'app-dropdown-filter',
  templateUrl: './dropdown-filter.component.html',
  styleUrls: ['./dropdown-filter.component.css']
})
export class DropdownFilterComponent extends BaseFilterCellComponent implements OnInit {
  // @ViewChild('select') select: MatSelect;
  // @ViewChild('search') inputVal;
  //@Input() public filter!: CompositeFilterDescriptor;
  @Input() public filter: any;
  @Input() public data!: string[];
  @Input() public Field!: string;
  public newlist2 :any= [];
  // public newList = [];
  // public selection = [];
  // public allSelected=false;
  // public isDisabled = false;
  
  constructor(filterService: FilterService) { super(filterService); }

  ngOnInit() {
    this.data = this.data.map((x:any) => x[this.Field]).filter((x, idx, xs) => xs.findIndex(y => y === x && y!=null && y!="" && y!=" ") === idx).sort();
    // this.newList = this.data;
    // if (!this.newList.length)
    //   this.isDisabled=true;

    this.data.forEach((element,idx) => {
      this.newlist2.push({id:idx,name:element})
    });
  }

  /*
  Manual Filter
  **
  toggleAllSelection() {
    if (this.allSelected) {
      this.select.options.forEach((item: MatOption) => item.select());
    }
    else {
      this.select.options.forEach((item: MatOption) => item.deselect());
    }
  }

  optionClick() {
    let newStatus = true;
    this.select.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.allSelected = newStatus;
  }

  public onChange(val: any): void {
    this.applyFilter(this.removeFilter(this.Field))
    if(val.value.length) {
      let temp = []
      val.value.forEach(element => {
        temp.push({
          field: this.Field,
          operator: 'eq',
          value: element
        })
      });
      let filter = this.filter ? this.filter.filters : []
      filter.push({
        filters: temp,
        logic: 'or'
      })
      this.applyFilter({
        filters: filter,
        logic: 'and'
      }); // update the root filter
    }
  }

  onKey(value) { 
    this.newList = this.search(value);
  }
    
  search(value: string) { 
    let filter = value.toLowerCase();
    return this.data.filter(option => option.toLowerCase().startsWith(filter));
  }

  triggerEvent(val) {
    if (val===false) {
      this.inputVal.nativeElement.value = ''
      this.newList = this.data;
    }
  }
  */

  public onChange2(val: any): void {
    this.applyFilter(this.removeFilter(this.Field))
    if(val.emittingList.length) {
      let temp: { field: string; operator: string; value: any; }[] = []
      val.emittingList.forEach((element: { text: any; value: any}) => {
        temp.push({
          field: this.Field,
          operator: 'eq',
          value: this.newlist2.filter(x=>x.id==element.value)[0].name
        })
      });
      let filter = this.filter ? this.filter.filters : []
      filter.push({
        filters: temp,
        logic: 'or'
      })
      this.applyFilter({
        filters: filter,
        logic: 'and'
      }); // update the root filter
    }
  }
}